import { createSlice } from "@reduxjs/toolkit";
import { AddEmployee, UpdateEmployee, GetEmployeeNameList, GetEmployeeIdList, GetEmployeeDetail, GetEmployeeAssetList, GetEmployeeList } from "services/employee/employee.service";
import { toast } from 'react-toastify';

export const employeeAddSlice = createSlice({
  name: "employeeAdd",
  initialState: {
    employeeAdd: {},
    employeeAddLoading: false,
    employeeAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddEmployee.pending, (state) => {
      // toast.loading('We are adding the employee 🤯')
      state.employeeAddLoading = true
    });

    builder.addCase(AddEmployee.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New employee added successfully 👌');

      state.employeeAdd = action.payload
      state.employeeAddLoading = false
      state.employeeAddError = null
    });

    builder.addCase(AddEmployee.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the employee 😣")

      state.employeeAddLoading = false
      state.employeeAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const employeeUpdateSlice = createSlice({
  name: "employeeUpdate",
  initialState: {
    employeeUpdate: {},
    employeeUpdateLoading: false,
    employeeUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateEmployee.pending, (state) => {
      // toast.loading('We are updating the employee 🤯')
      state.employeeUpdateLoading = true
    });

    builder.addCase(UpdateEmployee.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.employeeUpdate = action.payload
      state.employeeUpdateLoading = false
      state.employeeUpdateError = null
    });

    builder.addCase(UpdateEmployee.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the employee 😣")

      state.employeeUpdateLoading = false
      state.employeeUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const employeeListSlice = createSlice({
  name: "employeeList",
  initialState: {
    employeeList: [],
    employeeListLoading: false,
    employeeListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetEmployeeList.pending, (state) => {
      state.employeeListLoading = true
    });

    builder.addCase(GetEmployeeList.fulfilled, (state, action) => {
      toast.dismiss();

      state.employeeList = action.payload
      state.employeeListLoading = false
      state.employeeListError = null
    });

    builder.addCase(GetEmployeeList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the employee 😣")

      state.employeeListLoading = false
      state.employeeListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const employeeNameListSlice = createSlice({
  name: "employeeNameList",
  initialState: {
    employeeNameList: [],
    employeeNameListLoading: false,
    employeeNameListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetEmployeeNameList.pending, (state) => {
      state.employeeNameListLoading = true
    });

    builder.addCase(GetEmployeeNameList.fulfilled, (state, action) => {
      toast.dismiss();

      state.employeeNameList = action.payload
      state.employeeNameListLoading = false
      state.employeeNameListError = null
    });

    builder.addCase(GetEmployeeNameList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the employee name 😣")

      state.employeeNameListLoading = false
      state.employeeNameListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const employeeIdListSlice = createSlice({
  name: "employeeIdList",
  initialState: {
    employeeIdList: [],
    employeeIdListLoading: false,
    employeeIdListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetEmployeeIdList.pending, (state) => {
      state.employeeIdListLoading = true
    });

    builder.addCase(GetEmployeeIdList.fulfilled, (state, action) => {
      toast.dismiss();

      state.employeeIdList = action.payload
      state.employeeIdListLoading = false
      state.employeeIdListError = null
    });

    builder.addCase(GetEmployeeIdList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the employee id 😣")

      state.employeeIdListLoading = false
      state.employeeIdListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const employeeAssetListSlice = createSlice({
  name: "employeeAssetList",
  initialState: {
    employeeAssetList: [],
    employeeAssetListLoading: false,
    employeeAssetListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetEmployeeAssetList.pending, (state) => {
      state.employeeAssetListLoading = true
    });

    builder.addCase(GetEmployeeAssetList.fulfilled, (state, action) => {
      toast.dismiss();

      state.employeeAssetList = action.payload
      state.employeeAssetListLoading = false
      state.employeeAssetListError = null
    });

    builder.addCase(GetEmployeeAssetList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the employee employee 😣")

      state.employeeAssetListLoading = false
      state.employeeAssetListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const employeeDetailSlice = createSlice({
  name: "employeeDetail",
  initialState: {
    employeeDetail: [],
    employeeDetailLoading: false,
    employeeDetailError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetEmployeeDetail.pending, (state) => {
      state.employeeDetailLoading = true
    });

    builder.addCase(GetEmployeeDetail.fulfilled, (state, action) => {
      toast.dismiss();

      state.employeeDetail = action.payload
      state.employeeDetailLoading = false
      state.employeeDetailError = null
    });

    builder.addCase(GetEmployeeDetail.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the employee detail😣")

      state.employeeDetailLoading = false
      state.employeeDetailError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});